import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  idChecklistServico: number | null;
  descricao: string | null;
};

type Action = {
  setIdChecklistServico: (idChecklistServico: number) => void,
  setDescricao: (descricao?: string) => void,
  clearFilters: () => void
};

export const useChecklistServicoLiberacaoListaFilters = create<State & Action>((set) => ({
  idChecklistServico: null,
  descricao: null,
  setIdChecklistServico: (idChecklistServico) => set({ idChecklistServico }),
  setDescricao: (descricao) => set({ descricao }),
  clearFilters: () => set({
    idChecklistServico: null,
    descricao: null,
  }),
}));

export const initialChecklistServicoLiberacaoFiltersValues: State = {
  idChecklistServico: null,
  descricao: null,
}